import { FC } from 'react';

interface IconMenuMemopadProps {
    className?: string;
}

const IconMenuMemopad: FC<IconMenuMemopadProps> = ({ className }) => {
    return (
        <svg width="18" height="20" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M0 448c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V128H0V448zM112 208h224C344.8 208 352 215.2 352 224c0 8.836-7.164 16-16 16h-224C103.2 240 96 232.8 96 224C96 215.2 103.2 208 112 208zM112 304h224c8.836 0 16 7.162 16 16c0 8.836-7.164 16-16 16h-224C103.2 336 96 328.8 96 320C96 311.2 103.2 304 112 304zM112 400h96c8.836 0 16 7.162 16 16c0 8.836-7.164 16-16 16h-96C103.2 432 96 424.8 96 416C96 407.2 103.2 400 112 400zM384 0H64C28.65 0 0 28.65 0 64v32h448V64C448 28.65 419.3 0 384 0z"
                fill="currentColor"
                strokeWidth="1.5"
            />
        </svg>
    );
};

export default IconMenuMemopad;
